import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-action',
    template: `
     <input
  type="checkbox"
  [checked]="params.node.data.isSelected"
  (change)="onCheckboxChange($event)"
  style="margin-left: 7px; margin-right: 6px; transform: scale(1.2); background:#F4C430"
/>
    <button title="Edit" (click)="edit($event);" class="btn btn-primary btn-outline btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem;" [disabled]="!hasPermission(128)">
        <i class="fas fa-pencil-alt"></i>
    </button>
    <button title="Delete" (click)="delete($event);" class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="padding: .3rem .8rem;margin-top:0rem;background:#d71920" [disabled]="!hasPermission(129)">
        <i class="far fa-trash-alt"></i>
    </button>
    <button title="Refresh Attribute" (click)="refreshAttribute($event);" class="btn btn-outline btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem;background:#F4C430" [disabled]="!hasPermission(126)">
        <i class="fas fa-refresh"></i>
    </button>
    <button
  title="Page Layout Details"
  (click)="pageLayoutDetails($event);"
  class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
  style="padding: .3rem .8rem;margin-top:0rem;background:#17a2b8"
>
    <i class="fas fa-list"></i>
</button>

  
`,
    standalone: false
})

export class VaultObjectRefereshButton implements ICellRendererAngularComp {

    params;
    label: string;
    permissions: number[] = [];
    isChecked: boolean = false;

    agInit(params): void {
        this.params = params;
        this.label = this.params.label || null;
        this.permissions = this.params.values || [];
        this.isChecked = this.params.node.data.selectinstance || false;
    }

    hasPermission(buttonId: number): boolean {
        return this.permissions.includes(buttonId);
    }

    refresh(params?: any): boolean {
        this.params = params;
        this.isChecked = this.params.node.data.selectinstance || false;
        return true;
    }

    edit($event) {
        if (this.params.edit instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            }
            this.params.edit(params);

        }
    }

    delete($event) {
        if (this.params.delete instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            }
            this.params.delete(params);

        }
    }

    refreshAttribute($event) {
        if (this.params.refreshAttribute instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            }
            this.params.refreshAttribute(params);

        }
    }

    
    pageLayoutDetails($event) {
    if (this.params.pageLayoutDetails instanceof Function) {
        const params = {
            event: $event,
            rowData: this.params.node.data
        };
        this.params.pageLayoutDetails(params);
    }
}

    addAttribute($event) {
        if (this.params.addAttribute instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            }
            this.params.addAttribute(params);

        }
    }

    onCheckboxChange(event: any) {
        const checked = event.target.checked;
      
        if (this.params?.node?.data) {
          this.params.node.data.isSelected = checked;
      
          if (this.params.onCheckboxChange instanceof Function) {
            if (this.params.onCheckboxChange instanceof Function) {
                this.params.onCheckboxChange({
                  checked: checked,
                  rowData: this.params.node.data  // ✅ always send rowData
                });
              }
          }
        } else {
          console.error('params.node.data is undefined');
        }
      }
      
    

}
